module.exports = __webpack_public_path__ + "img/btn_set_server.28513c4e.png";